import { combineReducers } from "redux";
import {
  ADD_SCHEDULE_REQUEST,
  CHANGE_STATUS_SCHEDULE_REQUEST,
  DELETE_SCHEDULE_REQUEST,
  UPDATE_SCHEDULE_REQUEST,
} from "../constants";
import { FETCH_DOCTOR_REQUEST } from "../../doctor/constants";
import { ScheduleAction, IsFetching, ScheduleItems } from "../types";
import { Action as DoctorAction } from "../../doctor/types";
import { getFailureActionType, getSuccessActionType } from "../../utils";

function items(state: ScheduleItems = {}, action: ScheduleAction | DoctorAction): ScheduleItems {
  let officeId = action.data ? action.data.officeId : 0;
  let selectedOfficeSchedules = null;

  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_REQUEST): {
      const newState = { ...state };
      action.payload.offices.forEach((office) => (newState[office.id] = office.schedules));
      return newState;
    }
    case getSuccessActionType(ADD_SCHEDULE_REQUEST):
      return { ...state, [officeId]: [...state[officeId], action.payload] };

    case UPDATE_SCHEDULE_REQUEST:
      selectedOfficeSchedules = state[officeId].map((schedule) =>
        schedule.id === action.data.scheduleId ? { ...schedule, isFetching: true } : schedule
      );
      return { ...state, [officeId]: selectedOfficeSchedules };

    case getSuccessActionType(UPDATE_SCHEDULE_REQUEST):
      selectedOfficeSchedules = state[officeId].map((schedule) =>
        schedule.id === action.data.scheduleId ? { ...action.payload, isFetching: false } : schedule
      );
      return { ...state, [officeId]: selectedOfficeSchedules };

    case getFailureActionType(UPDATE_SCHEDULE_REQUEST):
      selectedOfficeSchedules = state[officeId].map((schedule) =>
        schedule.id === action.data.scheduleId ? { ...schedule, isFetching: false } : schedule
      );
      return { ...state, [officeId]: selectedOfficeSchedules };

    case DELETE_SCHEDULE_REQUEST:
      selectedOfficeSchedules = state[officeId].map((schedule) =>
        schedule.id === action.data.scheduleId ? { ...schedule, isFetching: true } : schedule
      );
      return { ...state, [officeId]: selectedOfficeSchedules };

    case getSuccessActionType(DELETE_SCHEDULE_REQUEST):
      selectedOfficeSchedules = state[officeId].filter((schedule) => schedule.id !== action.data.scheduleId);
      return { ...state, [officeId]: selectedOfficeSchedules };

    case getFailureActionType(DELETE_SCHEDULE_REQUEST):
      selectedOfficeSchedules = state[officeId].map((schedule) =>
        schedule.id === action.data.scheduleId ? { ...schedule, isFetching: false } : schedule
      );
      return { ...state, [officeId]: selectedOfficeSchedules };

    case CHANGE_STATUS_SCHEDULE_REQUEST:
      selectedOfficeSchedules = state[officeId].map((schedule) =>
        schedule.id === action.data.scheduleId ? { ...schedule, isFetching: true } : schedule
      );
      return { ...state, [officeId]: selectedOfficeSchedules };

    case getSuccessActionType(CHANGE_STATUS_SCHEDULE_REQUEST):
      selectedOfficeSchedules = state[officeId].map((schedule) =>
        schedule.id === action.data.scheduleId ? { ...action.payload, isFetching: false } : schedule
      );
      return { ...state, [officeId]: selectedOfficeSchedules };

    case getFailureActionType(CHANGE_STATUS_SCHEDULE_REQUEST):
      selectedOfficeSchedules = state[officeId].map((schedule) =>
        schedule.id === action.data.scheduleId ? { ...schedule, isFetching: true } : schedule
      );
      return { ...state, [officeId]: selectedOfficeSchedules };

    default:
      return state;
  }
}

function isFetching(state: IsFetching = {}, action: ScheduleAction): IsFetching {
  let officeId = action.data ? action.data.officeId : 0;
  switch (action.type) {
    case ADD_SCHEDULE_REQUEST:
      return { ...state, [officeId]: true };
    case getSuccessActionType(ADD_SCHEDULE_REQUEST):
    case getFailureActionType(ADD_SCHEDULE_REQUEST):
      return { ...state, [officeId]: false };

    default:
      return state;
  }
}

export const schedules = combineReducers({ items, isFetching });
